export const SET_UNREAD_MESSAGES = 'SET_UNREAD_MESSAGES'

interface SetUnreadMessages {
  type: typeof SET_UNREAD_MESSAGES
  payload: string[]
}

export type ChatActionsTypes = SetUnreadMessages
